import { ThunkAction } from 'redux-thunk';

import * as CatalogClient from 'Clients/Catalog';
import * as ImagesClient from 'Clients/Images';

import { UserAction } from './index';
import { pushAnalytics } from 'Utils/Analytics';

export const LOGGING_IN = 'USER_LOGGING_IN';
export const LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const LOGIN_FAILED = 'USER_LOGIN_FAILED';

export default function login(attempt: TrykApi.Catalog.ICookieLogin): ThunkAction<Promise<any>, any, any> {
  return (dispatch, getState) => {
    dispatch(loggingIn());

    pushAnalytics('login-attempt');

    const loginRequests: Promise<any>[] = [
      CatalogClient.User.login(attempt),
      ImagesClient.User.loginOauth(attempt)];

    // yarn cache cleanconst request = CatalogClient.User.login(attempt);

    return Promise.all(loginRequests).then(
      x => {
        pushAnalytics('login', {
          loginStatus: 'complete'
        });

        ImagesClient.setImagesAuthorisation(x[1]);

        return dispatch(loginSuccess(x[0], x[1]));
      },
      err => {
        pushAnalytics('login', {
          loginStatus: 'error'
        });

        return dispatch(loginFailed());
      }
    );

    // return request;
  };
}

function loggingIn(): UserAction {
  return {
    type: LOGGING_IN
  };
}

function loginFailed(): UserAction {
  return {
    type: LOGIN_FAILED
  };
}

function loginSuccess(account: TrykApi.Catalog.IAccount, imagesToken: ImagesClient.Types.IOauthResult): UserAction {
  return {
    type: LOGIN_SUCCESS,
    account: account,
    imagesToken: imagesToken,
  };
}
